import React from 'react';
import { func, node, string, bool, oneOfType, object } from 'prop-types';
import { Link } from 'react-router-dom';

import Checkbox from '@material-ui/core/Checkbox';
import Divider from '@material-ui/core/Divider';
import Grid from '@material-ui/core/Grid';
import PhoneIcon from '@material-ui/icons/Phone';

import { useConnect } from './hooks';

import PrivacyPolicy from '../PrivacyPolicy/PrivacyPolicy';
import Button from '../Button/Button';
import Typography from '../Typography/Typography';
import ROUTES, { getPath } from '../../routes';

import messages from './messages';
import { makeURLWithParams } from '../../utils/globals';

const EmergencyButton = ({ phoneNumber }) => (
  <Grid container name="emergency" alignItems="center" justify="center">
    <Grid item>
      <PhoneIcon color="secondary" />
    </Grid>
    <Grid item>
      <Button content={messages.emergency} href={`tel:${phoneNumber}`} variant="underlined" />
    </Grid>
  </Grid>
);

EmergencyButton.propTypes = {
  phoneNumber: string,
};

const MyCheckbox = ({ style, onChange }) => (
  <Grid container name="checkbox" style={style} wrap="nowrap">
    {onChange !== true && (
      <Grid item>
        <Checkbox onChange={onChange} />
      </Grid>
    )}
    <Grid item container alignItems="center" spacing={1}>
      <Grid item>
        <Typography content={messages.checkbox} />
      </Grid>
      <Grid item>
        <Link to={makeURLWithParams(getPath(ROUTES.LEGISLATION), { pdf: 'term_condition' })} target="_blank" rel="noopener noreferrer">
          <Typography content={messages.termsAgreementLink} />
        </Link>
      </Grid>
    </Grid>
  </Grid>
);

MyCheckbox.propTypes = {
  style: object,
  onChange: func,
};

const Footer = ({ checkbox, children, direction = 'row', emergency, option, privacyPolicy }) => {
  const { isDownsized } = useConnect();
  return (
    <Grid container name="footer" style={{ maxWidth: '700px', height: '100%' }}>
      {privacyPolicy && <PrivacyPolicy />}
      {emergency && <EmergencyButton phoneNumber={emergency} />}
      {!isDownsized && <Divider style={{ width: '100%', alignSelf: 'flex-end' }} />}
      {checkbox && <MyCheckbox style={{ marginTop: 12 }} onChange={checkbox} />}
      <Grid item>{option}</Grid>
      <Grid item container style={{ marginTop: 12 }} direction={direction} justify="center" spacing={1}>
        {React.Children.toArray(children).map(child => (
          <Grid item key={child.key} xs>
            {child}
          </Grid>
        ))}
      </Grid>
    </Grid>
  );
};
Footer.displayName = 'Footer';

Footer.propTypes = {
  checkbox: oneOfType([func, bool]),
  privacyPolicy: bool,
  children: node.isRequired,
  direction: string,
  emergency: string,
  option: node,
};

export default Footer;
